<script lang="ts" setup>
import type { LocaleObject } from '@nuxtjs/i18n';

const { locale, t } = useEkI18n();
const settingsStore = useSettingsStore();
const userConfigurationAPI = useConfigurationAPI();
const { availableLocales } = useAvailableLocales();

const selectedLocale = computed(() => availableLocales.value.find((l) => l.code === settingsStore.settings.language));

async function setLanguage(locale: LocaleObject) {
  await settingsStore.set('language', locale.code);
  const localeUpdate: UserLocale = {
    Locale: locale.code
  };
  await userConfigurationAPI.UpsertLocale(localeUpdate);
}

function localeFlagClass(code: string) {
  const region = code.split('-')[1] ?? code;

  return `fi fi-${region.toLowerCase()}`;
}

function localeOptionFlagClass(code: string) {
  const region = code.split('-')[1] ?? code;

  return `locale-option-flag fi-${region.toLowerCase()}`;
}
</script>

<template>
  <SettingsSelect
    :options="availableLocales"
    :label="t('settings.general.language')"
    :placeholder="locale"
    :value="selectedLocale"
    :resolve-key="(o: LocaleObject)=>o.code"
    :option-class="(o: LocaleObject) => localeOptionFlagClass(o.code)"
    @change="setLanguage"
  >
    <template #valuePrefix>
      <span
        class="locale-flag"
        :class="localeFlagClass(selectedLocale?.code ?? locale)"
      />
    </template>
    <template #option="{ option }">
      {{ option.name }}
    </template>
  </SettingsSelect>
</template>

<style scoped>
.locale-flag {
  display: inline-block;
  width: 1.5rem;
  height: 1.125rem;
}
</style>

<style>

ion-item.locale-option-flag {
  background-repeat: no-repeat;
  background-position: 16px center;
  background-size: 1.5rem 1.125rem;
  padding-inline-start: 3rem;
}
</style>

